export enum buttonpanelAssetConfig {

    // IMAGE_BUTTON = "assets/buttonpanel/play01.json",
    // IMAGE_BET_BUTTON = "assets/buttonpanel/bet01.json",
    // ANIMATED_BUTTON = "assets/buttonpanel/logo_ja.json"

}